import React, { useState, useEffect } from 'react';
import './HomePage.css';

const HomePage = ({ userData }) => {
  const [stats, setStats] = useState({
    streak: 0,
    activitiesCompleted: 0,
    totalMinutesSaved: 0,
    weekProgress: [0, 0, 0, 0, 0, 0, 0],
  });

  useEffect(() => {
    loadStats();
  }, []);

  const loadStats = () => {
    const savedStats = localStorage.getItem('userStats');
    if (savedStats) {
      setStats(JSON.parse(savedStats));
    }
  };

  const dailyTips = [
    "Replace 10 minutes of scrolling with reading today",
    "Your brain needs deep focus, not constant stimulation",
    "Every activity completed strengthens your mental resilience",
    "Studies show short-form content reduces attention span by 40%",
    "You've got this! One day at a time",
  ];

  const randomTip = dailyTips[Math.floor(Math.random() * dailyTips.length)];

  const brainRotFacts = [
    {
      icon: '🧠',
      title: 'Decreased Attention Span',
      description: 'Studies show heavy social media users have attention spans comparable to goldfish (8-9 seconds)',
      color: '#ef4444',
    },
    {
      icon: '😴',
      title: 'Disrupted Sleep Patterns',
      description: 'Blue light and dopamine hits before bed reduce sleep quality by up to 30%',
      color: '#8b5cf6',
    },
    {
      icon: '💔',
      title: 'Mental Health Impact',
      description: 'Excessive short-form content linked to increased anxiety and depression rates',
      color: '#ec4899',
    },
  ];

  return (
    <div className="home-page">
      <div className="container">
        {/* Welcome Header */}
        <div className="welcome-header gradient-bg">
          <h1>Welcome back, {userData?.name || 'User'}! 👋</h1>
          <p>Keep building healthy digital habits</p>
        </div>

        {/* Stats Cards */}
        <div className="stats-grid">
          <div className="stat-card stat-fire">
            <div className="stat-icon">🔥</div>
            <div className="stat-content">
              <div className="stat-number">{stats.streak}</div>
              <div className="stat-label">Day Streak</div>
            </div>
          </div>

          <div className="stat-card stat-check">
            <div className="stat-icon">✅</div>
            <div className="stat-content">
              <div className="stat-number">{stats.activitiesCompleted}</div>
              <div className="stat-label">Activities</div>
            </div>
          </div>

          <div className="stat-card stat-time">
            <div className="stat-icon">⏰</div>
            <div className="stat-content">
              <div className="stat-number">{stats.totalMinutesSaved}</div>
              <div className="stat-label">Minutes Saved</div>
            </div>
          </div>
        </div>

        {/* Weekly Progress */}
        <div className="section">
          <h2 className="section-title">Weekly Progress</h2>
          <div className="card">
            <div className="week-chart">
              {['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'].map((day, index) => (
                <div key={day} className="day-column">
                  <div className="bar-container">
                    <div
                      className="bar"
                      style={{
                        height: `${(stats.weekProgress[index] / 5) * 100}%`,
                        backgroundColor: stats.weekProgress[index] > 0 ? '#6366f1' : '#e5e7eb',
                      }}
                    >
                      {stats.weekProgress[index] > 0 && (
                        <span className="bar-value">{stats.weekProgress[index]}</span>
                      )}
                    </div>
                  </div>
                  <div className="day-label">{day}</div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Daily Reminder */}
        <div className="reminder-card">
          <div className="reminder-header">
            <span className="reminder-icon">💡</span>
            <h3>Daily Reminder</h3>
          </div>
          <p className="reminder-text">{randomTip}</p>
        </div>

        {/* Brain Rot Facts */}
        <div className="section">
          <h2 className="section-title">Why Fight Brain Rot?</h2>
          <div className="facts-grid">
            {brainRotFacts.map((fact, index) => (
              <div key={index} className="fact-card">
                <div className="fact-icon" style={{ color: fact.color }}>
                  {fact.icon}
                </div>
                <h3 className="fact-title">{fact.title}</h3>
                <p className="fact-description">{fact.description}</p>
              </div>
            ))}
          </div>
        </div>

        {/* Quick Actions */}
        <div className="section">
          <h2 className="section-title">Quick Actions</h2>
          <div className="quick-actions">
            <button className="action-btn action-primary">
              <span>📚</span>
              <span>Start Reading</span>
            </button>
            <button className="action-btn action-secondary">
              <span>🧘</span>
              <span>Meditate 5 min</span>
            </button>
            <button className="action-btn action-tertiary">
              <span>🏃</span>
              <span>Quick Exercise</span>
            </button>
          </div>
        </div>

        {/* Motivational Quote */}
        <div className="quote-card">
          <div className="quote-icon">💪</div>
          <blockquote className="quote-text">
            "The secret of change is to focus all of your energy not on fighting the old,
            but on building the new."
          </blockquote>
          <cite className="quote-author">- Socrates</cite>
        </div>
      </div>
    </div>
  );
};

export default HomePage;